<script lang="ts">
    import type {DyResponsePopupTextType} from 'types/dy';
    import {modal} from 'general/store';

    import Paragraph from './Paragraph.svelte';

    import s from './style.module.css';

    export let value: DyResponsePopupTextType[] = [];
    export let template = 'circle';
    export let mobileMargin = '0px';
</script>

<div class="{s.desc} {s[template] || ''} {s[$modal.state]}" style="margin-top: {mobileMargin}">
    {#each value as item}
        {#if item.image}
            <div class={s.imgContainer}>
                <img src={item.image} alt={item.image} width="116px" height="62px" />

                <Paragraph {item} />
            </div>
        {:else}
            <Paragraph {item} />
        {/if}
    {/each}
</div>
